var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 104,
    viewBox: "0 0 65 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7237 15.9913L37.6848 1.11809C35.1556 -0.372698 32.0363 -0.372698 29.5071 1.11809L4.14786 16.1647C1.58495 17.6901 0 20.5157 0 23.5493V43.4496C0 45.1484 0.859922 46.6566 2.27626 47.506C3.70947 48.3554 5.41245 48.3554 6.82879 47.506L23.9935 37.3131C24.9546 36.7411 26.1686 36.7411 27.1297 37.3131L31.5979 39.9653C31.4462 40.6067 31.3619 41.2828 31.3619 41.9588V64.4767L4.45136 80.4767C3.01816 81.3261 2.1751 82.8342 2.1751 84.533C2.1751 86.2318 3.03502 87.74 4.45136 88.5894L29.3217 103.359C30.0298 103.775 30.8223 104 31.5979 104C32.3735 104 33.166 103.792 33.8742 103.359C35.3074 102.509 36.1505 101.001 36.1505 99.3023V67.3196L54.8327 56.2253C56.2659 55.3759 57.109 53.8678 57.109 52.169C57.109 50.4702 56.2659 48.9621 54.8327 48.1127L38.5616 38.4399L62.7237 24.104C64.1569 23.2546 65 21.7465 65 20.0477C65 18.3489 64.1569 16.8234 62.7237 15.9913ZM31.3787 98.9036L7.16602 84.533L31.3619 70.1625V98.9036H31.3787ZM52.118 52.1863L36.1673 61.6511V42.7042L52.118 52.1863ZM35.5435 34.5569C34.987 34.8862 34.4643 35.2849 34.0091 35.7356L29.524 33.0661C27.0791 31.61 24.0441 31.61 21.5992 33.0661L4.77173 43.0509V23.5493C4.77173 22.2665 5.44617 21.0531 6.52529 20.4117L31.8846 5.36511C32.4073 5.05309 32.9974 4.89707 33.5875 4.89707C34.1777 4.89707 34.7678 5.05309 35.2905 5.36511L60.0091 20.0303L35.5435 34.5569Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33.0159,
    y1: -37.9683,
    x2: 31.6953,
    y2: 103.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.8d3c6e4f.svg";
export { ForwardRef as ReactComponent };